import type { ReassignmentDetail, ReassignmentStatus } from '@cartwheel/api/v1'
import { Announcement, AnnouncementType } from '@cartwheel/components'

type ReassignmentAction = Exclude<ReassignmentStatus, 'initiated'>

interface ReassignmentWarningsProps {
  reassignment: ReassignmentDetail
  selectedAction?: ReassignmentAction | ''
}

export function ReassignmentWarnings({
  reassignment,
  selectedAction: _selectedAction,
}: ReassignmentWarningsProps) {
  return (
    <>
      {/* Repeat Reassignment Warning - Single Client */}
      {reassignment.reassignment_type === 'single_client' &&
        reassignment.journey_info.is_repeat_reassignment && (
          <Announcement
            type={AnnouncementType.Warning}
            message={`This client has had ${reassignment.journey_info.prior_approved_reassignment_count} prior approved reassignment(s).`}
          />
        )}

      {/* Repeat Reassignment Warning - Entire Caseload */}
      {reassignment.reassignment_type === 'entire_caseload' &&
        reassignment.journey_info.has_any_repeat_reassignments && (
          <Announcement
            type={AnnouncementType.Warning}
            message={`${reassignment.journey_info.clients_with_repeat_reassignments?.length} client(s) in this caseload have 2+ prior approved reassignments.`}
          />
        )}

      {/* Flagged Client Warnings - Single Client */}
      {reassignment.reassignment_type === 'single_client' &&
        reassignment.journey_info.clients_with_flags &&
        reassignment.journey_info.clients_with_flags[0] && (
          <Announcement
            type={AnnouncementType.Warning}
            title="Client has safety concerns"
            message={`This client has the following safety concerns: ${reassignment.journey_info.clients_with_flags[0].flags.join(', ')}.`}
          />
        )}

      {/* Flagged Client Warnings - Entire Caseload */}
      {reassignment.reassignment_type === 'entire_caseload' &&
        reassignment.journey_info.clients_with_flags &&
        reassignment.journey_info.clients_with_flags.length > 0 && (
          <Announcement
            type={AnnouncementType.Warning}
            title="Some clients have safety concerns"
            message={`The following client(s) have safety concerns: ${reassignment.journey_info.clients_with_flags.map((c) => c.name).join(', ')}. Visit client detail pages for more information.`}
          />
        )}
    </>
  )
}
